import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export const OPEN_ADD_TEMPLATE_DIALOG_EVENT = "openAddTemplateDialog";
export const SHOE_HIDDEN_SUGGESTED_ANSWERS_EVENT = "showHiddenSuggestedAnswers";

export function createEmptyMessageTemplateModel(): OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel {
    return {
        id: null,
        descr: null,
        text: null,
        categoryId: null,
        isEditable: true,
        isRemovable: true,
        isShared: false,
        systemTypeId: null,
        operators: [OperatorAccountStore.operator.value.id],
        attachments: [],
        operatorGroups: [],
        hasVariablesInText: false
    }
}